/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {ServerObject} from './server-object';

export class ServerObjectInstance extends BaseInstance {
  serverObject: ServerObject;
}
